module.exports = __webpack_public_path__ + "media/images/athletes/2816-1451df110e1da2053870cc299f94753d.png";